/**
 * @module course-details
 * @description Manages the dynamic display of course information based on the selected student type.
 * It persists the user's selection in sessionStorage and toggles the visibility of related content blocks.
 */
export default function initCourseDetails() {
    console.log("[Course Details] Component loaded");

    const STUDENT_TYPE_ID = "mu_student_type_id";
    const STUDENT_TYPE_URL_NAME = "mu_student_type_url_name";
    const URL_PARAM_NAME = "studentType";

    const $studentTypeSelect = $(".js-student-type-select");
    const $infoBlocks = $("[data-student-type]");

    if (!$studentTypeSelect.length) {
        return;
    }

    const getStudentTypeFromUrl = () => {
        try {
            const params = new URLSearchParams(
                window.location.search
            );

            return (
                params.get(URL_PARAM_NAME) || ""
            )
                .trim()
                .toLowerCase();
        } catch {
            return "";
        }
    };

    const updateUrlParameter = studentType => {
        try {
            const url = new URL(window.location.href);

            if (studentType) {
                url.searchParams.set(
                    URL_PARAM_NAME,
                    studentType
                );
            } else {
                url.searchParams.delete(
                    URL_PARAM_NAME
                );
            }

            window.history.replaceState(
                {},
                "",
                url.toString()
            );
        } catch {
            // ignore
        }
    };

    const dispatchStudentTypeChange = () => {
        document.dispatchEvent(
            new Event("studentTypeChange")
        );
    };

    const setStudentTypeSessionValue = () => {
        const studentTypeId =
            $studentTypeSelect.val();

        const $option =
            $studentTypeSelect.find(
                `option[value="${studentTypeId}"]`
            );

        const urlName = (
            $option.attr("data-url-name") || ""
        ).trim();

        try {
            sessionStorage.setItem(
                STUDENT_TYPE_ID,
                studentTypeId
            );

            sessionStorage.setItem(
                STUDENT_TYPE_URL_NAME,
                urlName
            );
        } catch {
            // ignore
        }

        updateUrlParameter(urlName);
        dispatchStudentTypeChange();
    };

    const updateInfoBlocks = selectedType => {
        const normalizedType =
            (selectedType || "").trim();

        $infoBlocks.hide();

        $infoBlocks
            .filter(
                `[data-student-type="${normalizedType}"]`
            )
            .show();
    };

    const urlStudentType =
        getStudentTypeFromUrl();

    let savedStudentTypeId = null;

    try {
        savedStudentTypeId = sessionStorage.getItem(
            STUDENT_TYPE_ID
        );
    } catch {
        // ignore
    }

    const $urlOption = $studentTypeSelect
        .find("option")
        .filter(function () {
            return (
                (
                    $(this).attr(
                        "data-url-name"
                    ) || ""
                )
                    .trim()
                    .toLowerCase() ===
                urlStudentType
            );
        })
        .first();

    if (
        urlStudentType &&
        $urlOption.length
    ) {
        const studentTypeId =
            $urlOption.val();

        $studentTypeSelect.val(
            studentTypeId
        );

        try {
            sessionStorage.setItem(
                STUDENT_TYPE_ID,
                studentTypeId
            );

            sessionStorage.setItem(
                STUDENT_TYPE_URL_NAME,
                urlStudentType
            );
        } catch {
            // ignore
        }

        updateUrlParameter(
            urlStudentType
        );

        updateInfoBlocks(
            urlStudentType
        );

        dispatchStudentTypeChange();
    } else {
        const $savedOption =
            $studentTypeSelect.find(
                `option[value="${savedStudentTypeId}"]`
            );

        const savedUrlName = (
            $savedOption.attr(
                "data-url-name"
            ) || ""
        ).trim();

        const sessionIsValid =
            !!savedStudentTypeId &&
            $savedOption.length > 0 &&
            !!savedUrlName;

        if (sessionIsValid) {
            $studentTypeSelect.val(
                savedStudentTypeId
            );

            updateUrlParameter(
                savedUrlName
            );

            updateInfoBlocks(
                savedUrlName
            );

            dispatchStudentTypeChange();
        } else {
            try {
                sessionStorage.removeItem(
                    STUDENT_TYPE_ID
                );

                sessionStorage.removeItem(
                    STUDENT_TYPE_URL_NAME
                );
            } catch {
                // ignore
            }

            const defaultType = (
                $studentTypeSelect
                    .find(":selected")
                    .attr(
                        "data-url-name"
                    ) || ""
            ).trim();

            setStudentTypeSessionValue();

            updateInfoBlocks(
                defaultType
            );
        }
    }

    $studentTypeSelect.on(
        "change",
        e => {
            const selectedType = (
                $(e.target)
                    .find(":selected")
                    .attr("data-url-name") || ""
            ).trim();

            setStudentTypeSessionValue();

            updateInfoBlocks(
                selectedType
            );
        }
    );
}